'use strict'

import React from 'react';

export default class FormattedContent extends React.Component {
  translateToHTML(content) {
    return content!==undefined && content!==null
      ? content.startsWith("<p>") || content.startsWith("<ul>") || content.startsWith("<ol>")
        ? content
        : content
          .replace(/\*/g,"<li/>")
          .replace(/\r\n/g,"<br/>")
          .replace(/\n/g,"<br/>")
      : "";
  }

  render() {
    return (typeof this.props.value)==="string" ? (
      <span dangerouslySetInnerHTML={{__html:this.translateToHTML(this.props.value)}}/>
    ) : this.props.value!==undefined ? this.props.value : null;
  }
}



// WEBPACK FOOTER //
// ./views/components/FormattedContent.jsx